// extracted by mini-css-extract-plugin
export default {"wrapper":"Description-module__wrapper--dc485","title":"Description-module__title--dbc5d"};